/*
* Adds Clients theme colors
* @usage append class "olo-client-theme-background for background" & "olo-client-theme-color for background color as font-color"
*/

export const AddClientThemeClasses = themeBackground => {
  const rules = [
    [
      '.btn-restaurant-info:hover,.btn-ok:hover,.btn-success.focus, .btn-success:focus,.btn-success.active, .btn-success:active, .open>.dropdown-toggle.btn-success,.sidenav .tab-menus .tab-item,.mainnav-active,.ajs-ok,.addressOrder,.orderColor,.checkAvailability,.customButton:hover,.customButton.active,.diningButton.active,.inactive:hover, .diningButton:hover,.olo-client-theme-background',
      ['background-color', '#' + themeBackground + ' !important'],
    ],
    [
      '.sidenav .active-menu .active-sub-menu a,.itemNutritionButton,.sub-menu > ul > li > a.active,input[type="checkbox"]:not(old):checked + label > span:before,.ajs-ok,.change-adr-text,.btn-success,.close,.addressName,.back,.skylight-dialog h2,.customButton,.addEditItemPopup .modifierTitle,.pickupTimeOption,.panel-login>.panel-heading a.active,.olo-client-theme-color',
      ['color', '#' + themeBackground + ' !important'],
    ],
    [
      '.panel-card:hover,.btn-success,.checkAvailability,.customButton,.customButton.active,.diningButton.active,.inactive:hover, .diningButton:hover,.olo-client-theme-border',
      ['border-color', '#' + themeBackground + ' !important'],
    ],

    [
      'input[type=radio]:not(old):checked + label > span > span',
      ['border', '0.0625em solid  #' + themeBackground + ' !important'],
      [
        'background-image',
        'linear-gradient(#' +
          themeBackground +
          ', #' +
          themeBackground +
          ' ) !important',
      ],
    ],
    [
      '.btn-restaurant-info:hover,.btn-ok:hover,.btn-success.focus, .btn-success:focus,.btn-success.active, .btn-success:active, .open>.dropdown-toggle.btn-success,.ajs-ok,.addToBagButton,.addressOrder,.checkAvailability,.btn:hover:not(.btn-link),.btn:not(.btn-link) span:hover,.btn.active,.customButton:hover,.olo-client-theme-color-white,.mainnav-active',
      ['color', 'white !important'],
    ],
    [
      '.nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover',
      ['border-bottom-color', '#' + themeBackground],
    ],
  ];

  if (!isFirefox()) {
    rules.push([
      '::-webkit-scrollbar-thumb,::-webkit-scrollbar-thumb:window-inactive',
      ['background', '#' + themeBackground + ' !important'],
    ]);
  }

  return addStylesheetRules(rules);
};

const isFirefox = () => {
  return (
    navigator.userAgent.search('Firefox') >= 0 &&
    navigator.userAgent.search('Chrome') < 0
  );
};

function addStylesheetRules(rules) {
  const styleEl = document.createElement('style');
  document.head.appendChild(styleEl);
  const styleSheet = styleEl.sheet;

  for (let i = 0, rl = rules.length; i < rl; i++) {
    let j = 1,
      rule = rules[i],
      selector = rules[i][0],
      propStr = '';
    if (Object.prototype.toString.call(rule[1][0]) === '[object Array]') {
      rule = rule[1];
      j = 0;
    }

    for (let pl = rule.length; j < pl; j++) {
      let prop = rule[j];
      propStr +=
        prop[0] + ':' + prop[1] + (prop[2] ? ' !important' : '') + ';\n';
    }

    // Insert CSS Rule
    styleSheet.insertRule(
      selector + '{' + propStr + '}',
      styleSheet.cssRules.length
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme.js